import { noop } from 'lodash';
import { RevisionActionProps } from 'components/tables/data/revision/types';
import { useApi } from 'api/api-context';
import { showNotification } from '@mantine/notifications';
import { SUCCESS_NOTIFICATION_COLOR } from 'utils/constants';
import panic from 'errors/panic';

/**
 * The parameters of the reject action.
 */
export interface RejectActionParams extends RevisionActionProps {
  reason?: string;
}

/**
 * Implements the reject action for revision.
 */
export default function useRejectAction() {
  const { getAction } = useApi();

  /**
   * Makes a call to the API to reject the revision.
   */
  async function rejectRevision({
    revision: { revisionId, revisionName, kind },
    reason,
    onStatusChange = noop,
  }: RejectActionParams) {
    const revisionRejectAction = getAction('RevisionReject');

    try {
      const { status } = await revisionRejectAction({
        parameters: { revisionId: String(revisionId) },
        payload: { reason },
      });

      onStatusChange({ revisionId, status, reason });

      showNotification({
        title: kind === 'revision' ? 'Revízna správa bola zamietnutá' : 'Formulár bol zamietnutý',
        message:
          kind === 'revision'
            ? `Revíznu správu ${revisionName} ste úspešne zamietli.`
            : `Formulár ${revisionName} ste úspešne zamietli.`,
        color: SUCCESS_NOTIFICATION_COLOR,
      });
    } catch (error: any) {
      panic(error);
    }
  }

  return { rejectRevision };
}
